import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import { connectRouter, routerMiddleware } from "connected-react-router";
import rootReducer from "reducers/rootReducer";
//import data from './data';

const initialState = {
  userSignin: {
    userInfo: localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null,
  },
  addRecord: {
    addFinanceRec: localStorage.getItem("addFinanceRec")
      ? JSON.parse(localStorage.getItem("addFinanceRec"))
      : {},
  },
  addCategory: {
    addCategoryRec: localStorage.getItem("addCategoryRec")
      ? JSON.parse(localStorage.getItem("addCategoryRec"))
      : {},
  },
  addYearlyReport: {
    addYearlyReport: localStorage.getItem("addYearlyReport")
      ? JSON.parse(localStorage.getItem("addYearlyReport"))
      : {},
  },
};

export const history = createBrowserHistory();
//const router = routerMiddleware(history);

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  //connectRouter(history)(rootReducer),
  rootReducer,
  //rootReducer,
  //reducer,
  initialState,
  composeEnhancer(applyMiddleware(thunk))
  //applyMiddleware(routerMiddleware(history))
);

export default store;
